export { Navbar } from "./navbar";
export { default as Hero } from "./Hero";

export { default as Features } from "./Features";
export { default as FeaturesSection } from "./FeaturesSection";
export { default as FAQ } from "./FAQ";
export { default as Pricing } from "./Pricing";
export { default as PricingComparator } from "./PricingComparator";
export { default as Integrations } from "./Integrations";
export { default as Footer } from "./Footer";
